import {Component} from "react";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import {withRouter} from 'react-router-dom'
import React from "react";
import {Card, Col, Row, Tooltip, Button} from "antd";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import _ from "lodash";
import { isEnterpriseUser } from "../../utils/plan-utils";

export class DashboardExtraFeatures extends Component {

  functionalServices = () => this.props.planServices.filter(e => e.type === "3").sort((a, b) => {
    // Sort active items first
    if (a.isnew && !b.isnew) {
      return -1;
    }
    if (!a.isnew && b.isnew) {
      return 1;
    }

    // Sort remaining items by ID
    return a.id - b.id;
  });

  render() {
    const {
      intl,
      handleShowModalExtraPayment,
      newColor,
      client
    } = this.props;

    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      /*initialSlide: 0,
      responsive: [
          {
              breakpoint: 1024,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: true
              }
          },
          {
              breakpoint: 600,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  initialSlide: 2
              }
          },
          {
              breakpoint: 480,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
              }
          }
      ]*/
    };

    return (
      <React.Fragment>
        <Card className="dashboard-extra-features" title={intl.formatMessage({id: 'features'})} extra={(
          <Tooltip title={'Aquí podrás adquirir nuevas funcionalidades'} placement={'left'} theme="outlined">
            <span style={{ cursor: 'pointer', }}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0ZM8 3.28C8.20569 3.28 8.40677 3.34099 8.57779 3.45527C8.74882 3.56955 8.88212 3.73197 8.96083 3.92201C9.03955 4.11204 9.06015 4.32115 9.02002 4.52289C8.97989 4.72463 8.88084 4.90994 8.73539 5.05539C8.58994 5.20084 8.40463 5.29989 8.20289 5.34002C8.00115 5.38015 7.79204 5.35955 7.60201 5.28084C7.41197 5.20212 7.24955 5.06882 7.13527 4.89779C7.021 4.72677 6.96 4.52569 6.96 4.32C6.96 4.04418 7.06957 3.77965 7.26461 3.58461C7.45965 3.38957 7.72417 3.28 8 3.28ZM10.56 11.82C10.56 12.0961 10.3361 12.32 10.06 12.32H6.26C5.98386 12.32 5.76 12.0961 5.76 11.82V11.54C5.76 11.2639 5.98386 11.04 6.26 11.04H7.52V7.52H6.74C6.46386 7.52 6.24 7.29614 6.24 7.02V6.74C6.24 6.46386 6.46386 6.24 6.74 6.24H8.3C8.57614 6.24 8.8 6.46386 8.8 6.74V11.04H10.06C10.3361 11.04 10.56 11.2639 10.56 11.54V11.82Z" fill="#3598CD"/>
              </svg>
            </span>
          </Tooltip>
        )}
              hoverable>
          <Row gutter={25}>
            <Col md={8} xs={24} span={8}>
              <img src="/images/img_v2/groups.svg" width="197" height="164" alt="groups"/>
              <p>{intl.formatMessage({id: 'learn_about_group_benefits'})}</p>
            </Col>
            <Col md={16} xs={24} span={16}>
              <div className="slider-wrapper">
                {Boolean(this.functionalServices().length) && <Slider {...settings}>
                  {
                    this.functionalServices().map(e => {
                      const result = this.props.userServices ? this.props.userServices.find(({ product }) => product === e.product) : null;
                      const hired = !_.isNil(result);
                      return (
                        <div
                          key = {e._id}
                        >
                          <div className="features">
                            <div className="wrapper">
                              {e.isnew ?  <span 
                                className="tag" style={{ 
                                  backgroundColor: "#008E35", 
                                  borderColor: newColor,
                                  fontWeight: 600
                                }}
                              >
                                Nueva funcionalidad
                              </span> : <span className="tag" style = {{backgroundColor: "rgba(241, 240, 240, 0.95)"}}></span>}
                              <div style={{ marginTop: 7, marginBottom: 5, }}>
                                {/* <div style={{ marginTop: 7, marginBottom: 5, }}>{`Contratar ${e.nickname}`}</div> */}
                                <span>{`Contratar `}</span>
                                <span style={{ fontWeight: 700 }}>{e.nickname.toUpperCase()}</span>
                              </div>  
                              <div style={{ color: 'var(--primary-color)', fontWeight: 700, fontSize: 14, marginBottom: 10, }}>{e.product}</div>
                              <ul style={{ fontSize: 12, marginLeft: 10 }}>
                                <li>{e.benefits[0].title}</li>
                                <li>{e.benefits[1].title}</li>
                                <li>{e.benefits[2].title}</li>
                                <li>{e.benefits[3].title}</li>
                              </ul>
                              <div className="action">
                              {!isEnterpriseUser(client.clientType) && <Button
                                style={{ backgroundColor: newColor, borderColor: newColor }}
                                type="primary"
                                onClick={() => {
                                  handleShowModalExtraPayment(hired ? undefined : e)
                                }}
                              >
                                {hired ? "Contratado" : intl.formatMessage({id: 'hire'})}
                              </Button>}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })
                  }
                </Slider>}
              </div>
            </Col>
          </Row>
        </Card>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  planServices: state.planServices.data,
  userServices: state.planServices.userServices,
  client: state.client.data,
});

export default injectIntl(withRouter(connect(mapStateToProps, {})(DashboardExtraFeatures)))
